export const ArrowRightDate = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.324143 13.707C-0.0663811 13.3165 -0.0663811 12.6834 0.324143 12.2928L5.61704 6.99994L0.324143 1.70704C-0.0663811 1.31652 -0.0663811 0.683354 0.324143 0.29283C0.714667 -0.0976944 1.34783 -0.0976944 1.73836 0.29283L7.63229 6.18677C8.08139 6.63586 8.0814 7.364 7.63229 7.81311L1.73836 13.707C1.34783 14.0976 0.714667 14.0976 0.324143 13.707Z"
        fill="currentColor"
      />
    </svg>
  )
}
